// Site-wide pages that the CMS can edit (non-service-offering pages).
// Same shape as services.js so list/edit components can share patterns.
// The `key` doubles as the Firestore doc id under `pageSettings`.
//
// Add a new page here and it shows up automatically in /cms/pages.
export const SITE_PAGES = [
  {
    key: "homepage",
    label: "Homepage",
    path: "/",
    defaultHeading: "Leechiu Property Consultants",
    description: "Site's landing page — first impression for visitors.",
  },
  // `property-search` intentionally lives in its own top-level CMS tab
  // (see PropertySearchHome.jsx) since it will grow into a full property
  // listings manager — leaving it out of General Pages.
  {
    key: "list-properties",
    label: "List Your Property",
    path: "/list-properties",
    defaultHeading: "List Your Property",
    description: "Form for property owners to submit listings.",
  },
  {
    key: "about-us",
    label: "About Us",
    path: "/aboutUs",
    defaultHeading: "About Us",
    description: "Company background, history, and leadership.",
  },
  {
    key: "contact-us",
    label: "Contact Us",
    path: "/contactUs",
    defaultHeading: "Contact Us",
    description: "Contact form and office information.",
  },
];

export function getSitePageByKey(key) {
  return SITE_PAGES.find((p) => p.key === key);
}
